import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import Navbar from "../Components/Navbar";
import { useNavigate } from "react-router-dom";
import jwt_decode from "jwt-decode";

const Search = () => {
  const [supplierData, setSupplierData] = useState([]);
  const [user, setUser] = useState("");
  const [userName, setUserName] = useState("");
  const [searchName, setSearchName] = useState("");
  const [searchId, setSearchId] = useState("");
  const navigate = useNavigate();

  const fetchSupplierData = async () => {
    try {
      const token = localStorage.getItem("token");
      console.log("[Search] Fetching supplier data...");
      console.log("[Search] API URL:", `${process.env.REACT_APP_API_BASEURL}/supplierNames`);
      console.log("[Search] Token exists:", !!token);
      
      const response = await axios.get(`${process.env.REACT_APP_API_BASEURL}/supplierNames`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      
      console.log("[Search] API Response status:", response.status);
      console.log("[Search] API Response data:", response.data);
      console.log("[Search] Number of suppliers returned:", response.data?.length || 0);
      
      return response.data;
    } catch (error) {
      console.error("[Search] Error fetching supplier data:", error);
      console.error("[Search] Error response:", error.response?.data);
      console.error("[Search] Error status:", error.response?.status);
      return [];
    }
  };

  useEffect(() => {
    console.log("[Search] Component mounted, fetching supplier data...");
    fetchSupplierData().then((data) => {
      console.log("[Search] Supplier data received:", data);
      console.log("[Search] Setting supplier data, count:", data?.length || 0);
      setSupplierData(data);
    });
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      const decoded = jwt_decode(token);
      console.log("[Search] Decoded token:", decoded);
      console.log("[Search] User from token:", decoded.user);
      console.log("[Search] Username from token:", decoded.username);
      console.log("[Search] Role from token:", decoded.role);
      setUser(decoded.user);
      setUserName(decoded.username);
    } else {
      console.error("[Search] Token not found in localStorage.");
    }
  }, []);

  const filteredSuppliers = useMemo(() => {
    return supplierData
      .filter((supplier) =>
        searchName ? supplier.name?.toLowerCase().includes(searchName.toLowerCase()) : true
      )
      .filter((supplier) =>
        searchId ? supplier.supplier?.toLowerCase().includes(searchId.toLowerCase()) : true
      );
  }, [supplierData, searchName, searchId]);

  const handleSupplierClick = (supplier) => {
    const normalizedCode = supplier?.supplier?.trim() || "";
    const normalizedName = supplier?.name?.trim() || supplier?.supplier || "";

    fetchSupplierDataForHome(normalizedCode);
    localStorage.setItem("currentUser", normalizedCode);
    localStorage.setItem("supplierName", normalizedName);

    window.dispatchEvent(
      new CustomEvent("supplierContextChanged", {
        detail: {
          supplier: normalizedCode,
          name: normalizedName
        }
      })
    );

    navigate(`/Home`);
  };

  return (
    <div className="customer-layout">
      <Navbar />
      <main className="customer-main">
        <section className="card admin-switcher">
          <header className="card-header card-header--stacked">
            <h1 className="page-hero__title">Switch Supplier Context</h1>
            <p className="page-subtitle">
              Signed in as <strong>{userName || user || "Admin"}</strong>. Pick a supplier below to
              view the tenant experience.
            </p>
          </header>

          <div className="admin-switcher__filters">
            <div className="form-field">
              <label htmlFor="filter-name">Supplier Name</label>
              <div className="form-field-control">
                <input
                  id="filter-name"
                  type="text"
                  placeholder="Search by supplier name"
                  value={searchName}
                  onChange={(event) => setSearchName(event.target.value)}
                />
              </div>
            </div>
            <div className="form-field">
              <label htmlFor="filter-id">Supplier ID</label>
              <div className="form-field-control">
                <input
                  id="filter-id"
                  type="text"
                  placeholder="Search by supplier ID"
                  value={searchId}
                  onChange={(event) => setSearchId(event.target.value)}
                />
              </div>
            </div>
            <div className="switcher-meta">
              <span className="switcher-meta__count">
                {filteredSuppliers.length} {filteredSuppliers.length === 1 ? "result" : "results"}
              </span>
            </div>
          </div>

          <div className="admin-switcher__list">
            {filteredSuppliers.length === 0 ? (
              <div className="notes-empty">No suppliers match your search yet.</div>
            ) : (
              filteredSuppliers.map((supplier) => (
                <button
                  type="button"
                  key={supplier.supplier}
                  className="admin-supplier-card"
                  onClick={() => handleSupplierClick(supplier)}
                >
                  <div className="admin-supplier-card__details">
                    <span className="admin-supplier-card__name">{supplier.name}</span>
                    <span className="admin-supplier-card__id">{supplier.supplier}</span>
                  </div>
                  <span className="admin-supplier-card__action">View</span>
                </button>
              ))
            )}
          </div>
        </section>
      </main>
    </div>
  );
};

export const fetchSupplierDataForHome = async (supplierId) => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.get(process.env.REACT_APP_API_BASEURL + "/api/Home/supplierdata/" + supplierId, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data; // Return the data
  } catch (error) {
    console.error("Error fetching supplier data for Home:", error);
    throw error;
  }
};

export default Search;
